export enum ViewState {
    Create = 1, Edit, Details
}